import { cloneDeep } from 'lodash';
import * as React from 'react';

import { IDocument, IBranding, IUserData } from '../../../../infrastructure/interfaces';
import BrandingListEditorForm from '../../../DocumentEditor/BrandingListEditorForm';
import SettingsNav from './SettingsNav';

export interface IBrandingListEditorProps {
  document: IDocument;
  userData: IUserData;
  brandingsList: IBranding[];
  updateDocument(document: IDocument, userID: string): void;
  updateModelDocument?(document: IDocument): void;
  cancelDocument?(): void;
}
export interface IBrandingListEditorState {
  document: IDocument;
  brandingsList: IBranding[];
}

export default class BrandingListEditor extends React.Component<IBrandingListEditorProps, IBrandingListEditorState> {
  constructor(props: IBrandingListEditorProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
      brandingsList: props.brandingsList,
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: IBrandingListEditorProps) {
    if (this.props.document !== nextProps.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  toggleBranding = (branding: IBranding) => {
    let brandings = [...this.state.document.brandings];

    if (brandings.find(c => c.id === branding.id)) {
      brandings = brandings.filter(c => c.id !== branding.id);
    } else {
      brandings.push(branding);
    }

    this.setState({
      document: {
        ...this.state.document,
        brandings,
      },
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  save = () => {
    this.props.updateDocument(this.state.document, this.props.userData.id);
  }

  render() {
    return (
      <div className="cropsEditorContainer">
        <SettingsNav
          onSave={this.save}
          cancel={this.cancel}
          document={this.state.document}
        />
        <div className="">
          <div className="cropsContainerTitle">
            {this.state.document.type === 'Bulletin' ? 'Footer Branding' : 'Back Cover Branding'}
          </div>
          <div className="cropsContainerWarning">
            "Does not apply to Dyna-Gro Quad Fold Covers"
          </div>
        </div>
        <BrandingListEditorForm
          className="settingsCropsListContainer settingsCropsListContainer--logo"
          document={this.state.document}
          brandingsList={this.state.brandingsList}
          onBrandChange={this.toggleBranding}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/BrandingListEditor.tsx